import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import InputText from "../../utils/InputText";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./changePassword.data.form";

const ChangePasswordForm = (props) => {
  const { t, handleSubmit, isFirst } = props;

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-5 mb-5">
        <div className="row">
          <div className="col-12 mb-3">
            <h3>
              <ins>{t("forms.security.changePass")}</ins>
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <p>{t("forms.security.text")}</p>
          </div>
        </div>
        <form className="form-horizontal bordered-row" onSubmit={handleSubmit}>
          {isFirst && (
            <div className="row">
              <div className="col-12">
                <Field
                  id="temporalPassword"
                  className="form-control"
                  labelField={t("forms.security.labels.temporalPassword")}
                  name="temporalPassword"
                  component={InputText}
                  fieldType="password"
                  showHidePassword
                  placeholder=""
                />
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-12">
              <Field
                id="password"
                className="form-control"
                labelField={t("forms.security.labels.password")}
                name="password"
                component={InputText}
                fieldType="password"
                showHidePassword
                placeholder=""
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Field
                id="passwordConfirm"
                className="form-control"
                labelField={t("forms.security.labels.passwordConfirm")}
                name="passwordConfirm"
                component={InputText}
                fieldType="password"
                showHidePassword
                placeholder=""
              />
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-8 text-end">
              <button type="submit" className="btn btn-lg btn-primary">
                {t("forms.security.buttons.save")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

ChangePasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

const ChangePasswordFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (isFirst) => {
    return validationDataModel(isFirst);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ChangePasswordForm",
})(withTranslation()(ChangePasswordForm));

export default ChangePasswordFormF;
